import { getFirebaseErrorCode } from "./get-firebase-error-code";

const offlineCodes = new Set([
  "unavailable", // Firestore
  "auth/network-request-failed", // Firebase Auth
  "remoteconfig/fetch-client-network", // Remote Config
  "remoteconfig/fetch-timeout", // Remote Config
]);

export function isFirebaseOfflineError(error: unknown): boolean {
  return offlineCodes.has(getFirebaseErrorCode(error) ?? "");
}
